import { BusinessInterface } from '@app/models/business';
import { UserInterface } from '@app/models/user';
import { IntegrationType } from '@app/utils/consts';

export enum ErrorLogType {
  SYSTEM_ERROR = 'SYSTEM_ERROR',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  INTEGRATION_ERROR = 'INTEGRATION_ERROR',
  AUTHENTICATION_ERROR = 'AUTHENTICATION_ERROR',
  AUTHORIZATION_ERROR = 'AUTHORIZATION_ERROR',
  NETWORK_ERROR = 'NETWORK_ERROR',
  DATABASE_ERROR = 'DATABASE_ERROR',
  BUSINESS_LOGIC_ERROR = 'BUSINESS_LOGIC_ERROR',
  QUEUE_ERROR = 'QUEUE_ERROR',
}

export enum ErrorLogLevel {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  CRITICAL = 'CRITICAL',
}

export interface ErrorLogMetadata {
  code?: number;
  url?: string;
  method?: string;
}

export interface ErrorLogInterface {
  id: string;
  type: ErrorLogType;
  level: ErrorLogLevel;
  message: string;
  stackTrace: string;
  userId: string;
  businessId: string;
  user?: UserInterface;
  business?: BusinessInterface;
  integrationType?: IntegrationType;
  metadata?: ErrorLogMetadata;
  createdAt: string;
}
